/**
 * @fileoverview Organism: the brand bar and the mode picker.
 * @module components/organisms/AppHeader
 */

import { BrandTitle, ModeSwitch } from "@/components/molecules"
import type { AppMode } from "@/types/types"

import "./AppHeader.css"

/** Props accepted by {@link AppHeader}. */
export interface AppHeaderProps {
	/** The active mode. */
	readonly mode: AppMode
	/** Flips to the other mode. */
	readonly onSwitch: () => void
	/** Disables the picker, e.g. while the session is still loading. */
	readonly disabled?: boolean
}

/**
 * Brand header.
 *
 * @description
 * Deliberately thin: the screen below it is the whole product, and anything
 * here competes with it. It carries the two things that must stay reachable
 * at all times — which mode you are in, and how to leave it.
 *
 * @param props - Active mode, switch callback and disabled flag.
 * @returns The rendered bar.
 */
export function AppHeader({
	mode,
	onSwitch,
	disabled = false,
}: AppHeaderProps) {
	return (
		<header className="app-header">
			<BrandTitle mode={mode} />
			<ModeSwitch mode={mode} onSwitch={onSwitch} disabled={disabled} />
		</header>
	)
}
